"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ShadowPosition = void 0;
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
var _context = require("../context");
var _layout = require("../layout");
let ShadowPosition = exports.ShadowPosition = /*#__PURE__*/function (ShadowPosition) {
  ShadowPosition["Top"] = "top";
  ShadowPosition["Bottom"] = "bottom";
  return ShadowPosition;
}({});
const RowWithShadow = (0, _context.styledWithTheme)(_layout.Row)(_ref => {
  let {
    theme,
    hasShadow,
    shadowPosition,
    hasBorder,
    isFooter
  } = _ref;
  const isTop = shadowPosition === ShadowPosition.Top;
  const BORDER_COLOR = (0, _utils.token)('color.border.primary');
  const transparent = (0, _utils.token)('color.transparent.alpha0');
  const shadowColor = (0, _utils.token)('color.gradient.elevation');
  const gradient = isTop ? "linear-gradient(".concat(transparent, ", ").concat(shadowColor, ")") : "linear-gradient(".concat(shadowColor, ", ").concat(transparent, ")");
  return {
    position: 'relative',
    ...(hasBorder && !isFooter && {
      borderBottomWidth: 1,
      borderBottomStyle: 'solid',
      borderBottomColor: BORDER_COLOR
    }),
    ...(hasBorder && isFooter && {
      borderTopWidth: 1,
      borderTopStyle: 'solid',
      borderTopColor: BORDER_COLOR
    }),
    ':before': {
      // The shadow won't appear unless the element has content, and
      // the value needs to include quotes so that they are applied in
      // the actual CSS - `content: ' '` would result in invalid CSS
      // because the string wouldn't be quoted in the DOM.
      content: '" "',
      transition: 'opacity 0.3s',
      opacity: hasShadow ? 1 : 0,
      position: 'absolute',
      top: isTop ? -5 : undefined,
      bottom: isTop ? undefined : -5,
      height: 5,
      left: 0,
      right: 0,
      background: gradient
    },
    ...(isFooter && theme.mediaQueries.sm({
      flexDirection: 'column',
      button: {
        width: 'fill-available'
      }
    }))
  };
});
RowWithShadow.displayName = 'RowWithShadow';
RowWithShadow.defaultProps = {
  ..._layout.Row.defaultProps
};
var _default = exports.default = RowWithShadow;